/**
 * The dashboard's half of scroll restoration: how a TanStack location names its
 * history ENTRY. Everything else — the three arrival cases, the retrying
 * restore, the hook — lives in `@authe/ui-core` (`utils/scrollRestoration`),
 * shared with the admin and QA portals, which had the same `<main>` scroll
 * container and no restoration at all.
 */
export {
  arrivalKind,
  restoreScroll,
  useScrollRestoration,
  RESTORE_DEADLINE_MS,
  RESTORE_SETTLE_MS,
  type ArrivalKind,
  type RestoreScrollOptions,
  type ScrollMemory,
} from "@authe/ui-core";

/**
 * The history entry's own identity, which is what makes "have I been here
 * before" answerable.
 *
 * TanStack stores a per-entry key in `location.state.__TSR_key` (the same field
 * its own scroll restoration keys on). Before the first navigation there is no
 * key yet, and `href` is the honest fallback: on a first paint there is nothing
 * remembered under it either way.
 */
export function scrollKeyOf(location: {
  href: string;
  state?: { __TSR_key?: string } | undefined;
}): string {
  return location.state?.__TSR_key || location.href;
}
